import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SellerKycGuidePage.module.css';
import { useTranslation } from 'react-i18next';

const SellerKycGuidePage = () => {
  const { t } = useTranslation('kycGuide');
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>{t('title')}</h1>
        <p className={styles.lead}>{t('lead')}</p>

        <p className={styles.text}>{t('intro1')}</p>
        <p className={styles.text}>{t('intro2')}</p>

        <h2 className={styles.sectionTitle}>{t('overviewTitle')}</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}><img src="/icons/clock.svg" alt="" className={styles.inlineIcon} />{t('overviewTime')}</li>
          <li className={styles.listItem}><img src="/icons/camera.svg" alt="" className={styles.inlineIcon} />{t('overviewDoc')}</li>
          <li className={styles.listItem}><img src="/icons/ginko.svg" alt="" className={styles.inlineIcon} />{t('overviewBank')}</li>
        </ul>
        <p className={styles.note}>{t('noteNameMatch')}</p>
        <p className={styles.note}>{t('noteSoleProprietor')}</p>
        <p className={styles.note}>{t('noteSoleProprietor2')}</p>

        <h2 className={styles.sectionTitle}>{t('guideTitle')}</h2>
        <p className={styles.text}>{t('guideIntro')}</p>

        <h3 className={styles.subTitle}>{t('bizTypeTitle')}</h3>
        <p className={styles.text}>{t('bizTypeOptions')}</p>
        <ul className={styles.list}>
          <li className={styles.listItem}>{t('bizTypeSole')}</li>
          <li className={styles.listItem}>{t('bizTypeCorp')}</li>
          <li className={styles.listItem}>{t('bizTypeNonProfit')}</li>
        </ul>
        <p className={styles.text}>{t('bizTypeNote')}</p>

        <h3 className={styles.subTitle}>{t('industryTitle')}</h3>
        <p className={styles.text}>{t('industryNote')}</p>

        <h3 className={styles.subTitle}>{t('websiteTitle')}</h3>
        <p className={styles.text}>{t('websiteNote1')}</p>
        <p className={styles.text}>{t('websiteNote2')}</p>
        <ul className={styles.list}>
          <li className={styles.listItem}>{t('websiteEx1')}</li>
          <li className={styles.listItem}>{t('websiteEx2')}</li>
          <li className={styles.listItem}>{t('websiteEx3')}</li>
        </ul>
        <p className={styles.note}>{t('websiteExNote')}</p>

        <h3 className={styles.subTitle}>{t('descTitle')}</h3>
        <p className={styles.exampleLabel}>{t('labelOrganizer')}</p>
        <p className={styles.text}>{t('descOrganizer')}</p>
        <p className={styles.exampleLabel}>{t('labelArtist')}</p>
        <p className={styles.text}>{t('descArtist')}</p>
        <p className={styles.exampleLabel}>{t('labelVenue')}</p>
        <p className={styles.text}>{t('descVenue')}</p>

        <h2 className={styles.sectionTitle}>{t('faqTitle')}</h2>
        <h3 className={styles.subTitle}>{t('faqQ1')}</h3>
        <p className={styles.text}>{t('faqA1')}</p>

        <h3 className={styles.subTitle}>{t('faqQ2')}</h3>
        <p className={styles.text}>{t('faqA2')}</p>

        <h2 className={styles.sectionTitle}>{t('startTitle')}</h2>
        <p className={styles.text}>{t('startText')}</p>

        <div className={styles.backRow}>
          <Link className={styles.backLink} to="/dashboard">{t('backLink')}</Link>
        </div>
      </div>
    </div>
  );
};

export default SellerKycGuidePage;
